export default "__VITE_ASSET__DHXvlT7A__"